import Repository from "./Repository";
import store from "../store";

const resource = "/SupplierApi";

export default {
  getApiCategories(supplierId) {
    return Repository.get(`${resource}/categories-by-supplier/${supplierId}`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  saveCategoriesByApi(categories, supplierId) {
    return Repository.post(
      `${resource}/save-categories-from-api/${supplierId}`,
      categories
    )
      .then((response) => {
        store.commit("setSnack", {
          message: "Категории сохранены",
          color: "success",
        });
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getCategoriesProperties(categoryId) {
    return Repository.get(`${resource}/get-categories-properties/${categoryId}`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
